import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useCartManagement = (refetch: () => void) => {
  const [isCartDialogOpen, setIsCartDialogOpen] = useState(false);

  const handleAddToCart = async (item: any, quantity: number) => {
    try {
      console.log("Starting add to cart process:", { item, quantity });
      
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        toast.error("Vous devez être connecté");
        return;
      }

      if (quantity <= 0) {
        toast.error("La quantité doit être supérieure à 0");
        return;
      }

      if (quantity > item.quantity) {
        toast.error("Quantité insuffisante en stock");
        return;
      }

      console.log("Attempting to insert into cart_items:", {
        stock_item_id: item.id,
        quantity,
        created_by: user.id
      });

      const { error } = await supabase
        .from('cart_items')
        .insert({
          stock_item_id: item.id,
          quantity: quantity,
          created_by: user.id
        });

      if (error) {
        console.error("Error adding to cart:", error);
        throw error;
      }

      toast.success("Produit ajouté au panier");
      refetch();
    } catch (error: any) {
      console.error("Erreur lors de l'ajout au panier:", error);
      toast.error(error.message || "Erreur lors de l'ajout au panier");
    }
  };

  return {
    isCartDialogOpen,
    setIsCartDialogOpen,
    handleAddToCart
  };
};